/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useParams } from 'react-router-dom';
import { Menu } from '../menu/Menu';
import { MenuMobile } from '../menu/MenuMobile';
import { GameIds } from '../my-games/MyGames.model';
import { Transitions } from '../transitions/Transitions';

interface PageProps {
  children: JSX.Element,
  hideMenu?: boolean
  disableTransitions?: boolean
}

export function PageLayout({ children, hideMenu = false, disableTransitions = false }: PageProps):JSX.Element {
  const { gameId } : { gameId: GameIds } = useParams();

  const getBackground = (): string => {
    switch (gameId) {
      case GameIds.DBD:
        return 'dbd-bg';
      case GameIds.HOY:
        return 'hoy-bg';
      case GameIds.MYM:
        return 'mym-bg';
      case GameIds.FM:
        return 'fm-bg';
      case GameIds.SOPHIA:
        return 'sophia-bg';
      default:
        return 'generic-bg';
    }
  };

  return (
    <>
      {!hideMenu && (
        <MenuMobile />
      )}
      <div className={`account-container ${getBackground()}`}>
        {!hideMenu && (
          <Menu />
        )}
        <div className='account-content'>

          <Transitions disableTransition={disableTransitions}>
            { children }
          </Transitions>

        </div>
      </div>
    </>
  );
}
